import { DRAFT_CREATE_ACTION } from '../Draft.constants'

export const DRAFT_CREATE_ACTION_SELECT_MODAL_FIELD_ACTION = 'action'

export const DRAFT_CREATE_ACTION_SELECT_MODAL_INITIAL_VALUES = {
  [DRAFT_CREATE_ACTION_SELECT_MODAL_FIELD_ACTION]:
    DRAFT_CREATE_ACTION.openDraft,
}
